// part of nuxt
import type { $Fetch, NitroFetchRequest } from "nitropack"

export function typesenseRepository<T>(fetch: $Fetch<T, NitroFetchRequest>) {
  return {
    /**
     * Returns job count from Typesense
     * @param tenantId targeted tenant
     * @param jobShopId id of the JobShop from which data is requested
     * @param typesenseApiKey API key for Typesense
     * @param typesenseUrl URL of the Typesense instance
     * @returns
     */
    async getJobCount(tenantId: string, jobShopId: string, typesenseApiKey: string, typesenseUrl: string): Promise<TypesenseResponse> {
      return fetch<TypesenseResponse>(`${typesenseUrl}/multi_search`, {
        method: "POST",
        headers: {
          "X-Tenant-Id": tenantId,
          "X-JobShop-Id": jobShopId,
          "X-Typesense-Api-Key": typesenseApiKey,
        },
        body: JSON.stringify({
          searches: [{
            facet_by: "department",
            collection: "offers",
            q: "*",
            page: 1,
            max_facet_values: 1000,
          }],
        }),
      })
    },
  }
}
